import React from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

const ConfirmDialog = ({
    visible,
    setVisible,
    onConfirm,
    onReject,
    process,
    message,
}) => {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        setVisible(false);
    };

    const handleReject = () => {
        if (onReject) {
            onReject();
        }
        setVisible(false);
    };

    const handleProcessType = () => {
        const processTypes = {
            save: "Kaydet",
            finishProcess: "Üretim Bitir ve Onaylama",
            add: "Ekleme",
            update: "Güncelleme",
            delete: "Silme",
            approve: "Onay",
            reject: "Ret",
            rollback: "Geri alma",
            closeOrder: "İş Emri Kapat",
            cancelProcess: "İlgili Bobinin üretimden çıkarma",
            getLevel2Info: "İlgili bobin bilgilerini Seviye-2'den alma",
            rewind: "Süreç geri sarma",
            finishProduction: "Üretim bitirme",
            cancelOperation: "Operasyon iptal",
        };
        return processTypes[process] || null;
    };

    const footerContent = (
        <div className="mt-3 flex justify-end gap-2 sm:gap-8">
            <Button
                label="İptal"
                icon="pi pi-times"
                onClick={handleReject}
                className="bg-transparent text-red-500 font-bold dark:text-white hover:text-white hover:bg-red-600 text-sm px-4 py-2 rounded-lg "
            />
            <Button
                label="Tamam"
                icon="pi pi-check"
                onClick={handleConfirm}
                autoFocus
                className="bg-green-500 hover:bg-green-700 text-white text-sm px-4 py-2 rounded-lg shadow-lg font-bold"
            />
        </div>
    );

    return (
        <Dialog
            header={null}
            visible={visible}
            footer={footerContent}
            style={{ width: "90vw", maxWidth: "600px" }}
            breakpoints={{ '960px': '90vw', '640px': '95vw' }}
            onHide={handleReject}
            pt={{
                root: { className: 'overflow-hidden' },
                header: { className: '!bg-[#ffbb00] border !border-[#ffbb00] p-0 h-5' },
                headerIcons: { className: 'hidden' },
                content: { className: 'py-6 px-2' },
                mask: { className: 'backdrop-blur-[1px] bg-black/50' }, // Hafif blur efekti ve yarı-saydam arka plan
            }}
        >
            <div className="grid grid-cols-4 back">
                <div className="flex items-center justify-center col-span-1">
                    <i className="pi pi-exclamation-triangle text-yellow-500 text-4xl md:text-6xl" />
                </div>
                <div className="flex-col items-center justify-center col-span-3 text-lg space-y-2">
                    <p className="text-base md:text-lg font-bold">Uyarı</p>
                    <p className="text-xs md:text-sm">
                        {message
                            ? message
                            : `${handleProcessType()} işlemini gerçekleştirmek istediğinizden emin misiniz?`}
                    </p>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmDialog;